import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import AdminAuthoritieContent from "./components/AdminAuthoritieContent";
const AddFinance = () => {
  return (
    <div>
      <TitleHolder>Add Finance</TitleHolder>
      <StepperContentHolder>
        <AdminAuthoritieContent />
      </StepperContentHolder>
    </div>
  );
};

export default AddFinance;
